import {
  DisputeItemSchema,
  disputeViewStatus,
} from "@redotech/redo-model/disputes/dispute-view";
import * as z from "zod/v4";

export const getDisputes = {
  name: "getDisputes" as const,
  input: z.object({ statuses: z.array(z.enum(disputeViewStatus)).optional() }),
  output: z.object({ disputes: z.array(DisputeItemSchema) }),
};
